/** classe util que vai auxiliar a iteração com localstorage */
class StorageUtil {
  /** Pega o token do localstorage*/
  static getItem(key: string) {
    return localStorage.getItem(key);
  }

  /**Salva o token no localstorage */
  static setItem(key: string, currentToken: string) {
    localStorage.setItem(key, currentToken);
  }

  /**Limpa o token da sessão */
  static remove(key: string) {
    localStorage.removeItem(key);
  }

  static cleanAll() {
    Object.entries(KEYS).forEach(([key, value]) => {
      StorageUtil.remove(value);
    });
  }
}

//Declaração das chaves
export const KEYS = {
  LOCKER_TOKEN: "@config-app/locker-token",
  LOCKER_UUID: "@config-app/locker-uuid",
  COMPANY_UUID: "@config-app/company-uuid",
  SEPARATOR_UUID: "@config-app/separator-uuid",
  SEPARATOR_TOKEN: "@config-app/separator-token",
  CORREIOS_SEPARATOR_REGISTRATION: "@config-app/correios-separator-registration",
};

export default StorageUtil;
